export enum FeatureFlagsEnum {
  RESOURCES_PAGE = 'resources_page',
  DASHBOARD_PAGE = 'dashboard_page',
  RESOURCES_TABLE = 'resources_table',
  RESOURCES_DETAILS = 'resources_details',
  PARTS_TABLE = 'parts_table',
  UPLOAD_PAGE = 'upload_page',
  ADMIN_PAGE = 'admin_page',
  CERTIFICATE = 'certificate',
  PROFILE_PAGE = 'profile_page',
  TEST_FEATURE = 'testFeature',
  OPEN_FEATURE = 'openFeature',
  ADD_RESOURCES = 'add_resources',
  ENTRA_LOGIN = 'entra_login',
  LICENSE_MANAGEMENT = 'license_management',
}
